window.FocusSamitaPricing = window.FocusSamitaPricing || (function () {
  function getDesktopSamitaPriceBlock() {
    return document.querySelector('[data-samita-price-source]');
  }

  function getSamitaPriceHTML() {
    var source = getDesktopSamitaPriceBlock();

    if (!source) return null;

    var price = source.querySelector('.samitaWS-customized-price');
    var original = source.querySelector('.samitaWS-customized-original-price');

    if (!price) return null;

    return {
      priceHTML: price.outerHTML,
      originalHTML: original ? original.outerHTML : '',
      fullHTML: source.innerHTML
    };
  }

  function renderInto(target) {
    if (!target) return false;

    var samita = getSamitaPriceHTML();

    if (!samita) return false;

    target.innerHTML = samita.fullHTML;
    target.setAttribute('data-samita-adapted', 'true');

    return true;
  }

  return {
    getSamitaPriceHTML: getSamitaPriceHTML,
    renderInto: renderInto
  };
})();